import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getPlanRecommendationQueryFn } from './queries/get-plan-recommendation.query';
import { getPlanRecommendationTierQueryFn } from './queries/get-plan-recommendation-tier.query';
export const PlanRecommendationQueriesConfig = createQueriesConfig({
  getPlanRecommendation: {
    queryFn: getPlanRecommendationQueryFn
  },
  getPlanRecommendationTier: {
    queryFn: getPlanRecommendationTierQueryFn
  }
});
//# sourceMappingURL=plan-recommendation.queries.js.map